/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RepostOfRepostNotificationActionData } from './RepostOfRepostNotificationActionData';
import {
    RepostOfRepostNotificationActionDataFromJSON,
    RepostOfRepostNotificationActionDataFromJSONTyped,
    RepostOfRepostNotificationActionDataToJSON,
} from './RepostOfRepostNotificationActionData';

/**
 * 
 * @export
 * @interface RepostOfRepostNotificationAction
 */
export interface RepostOfRepostNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof RepostOfRepostNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof RepostOfRepostNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {RepostOfRepostNotificationActionData}
     * @memberof RepostOfRepostNotificationAction
     */
    data: RepostOfRepostNotificationActionData;
}

/**
 * Check if a given object implements the RepostOfRepostNotificationAction interface.
 */
export function instanceOfRepostOfRepostNotificationAction(value: object): value is RepostOfRepostNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function RepostOfRepostNotificationActionFromJSON(json: any): RepostOfRepostNotificationAction {
    return RepostOfRepostNotificationActionFromJSONTyped(json, false);
}

export function RepostOfRepostNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepostOfRepostNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': RepostOfRepostNotificationActionDataFromJSON(json['data']),
    };
}

export function RepostOfRepostNotificationActionToJSON(value?: RepostOfRepostNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': RepostOfRepostNotificationActionDataToJSON(value.data),
    };
}

